/** 评论类型 */
export const CommentType = {
  /** 跟进 */
  FollowUp: 0,
  /** 汇报 */
  Report: 1,
}
